export const activeArray = [
    { title: "property", active: false },
    { title: "valuation", active: false },
    { title: "sale", active: false },
    { title: "site", active: false },
    { title: "primary_structures", active: false },
    { title: "secondary_structures", active: false },
    { title: "data_elements", active: false },
    { title: "improvements", active: false },
    { title: "buildings", active: false },
    { title: "yardwork", active: false },
    { title: "additional_data", active: false }
]

export const propertyArray = [
    {
        id: "roll_num",
        title: "property-information.roll-number",
        value: "",
    },
    {
        id: "property_address",
        title: "property-information.property-address",
        value: "",
    },
    {
        id: "legal_desc",
        title: "property-information.legal-description",
        value: "",
    },
    {
        id: "municipality",
        title: "property-information.municipality",
        value: "",
    },
    {
        id: "property_code_desc",
        title: "property-information.property-description",
        value: "",
    },
    {
        id: "homo_nbhd",
        title: "property-information.local-identifier",
        value: "",
    },
]

export const valuationArray = [
    {
        id: "current_value_assessment",
        title: "valuation.current-value-assessment",
        value: "",
    },
    {
        id: "realty_tax_classes",
        title: "valuation.realty-tax-classes",
        value: "",
    },
    {
        id: "base_year",
        title: "valuation.base-year",
        value: ""
    },
    {
        id: "improvements",
        title: "",
        value: []
    }
]

export const saleArray = [
    {
        id: "sale_dte",
        title: "sale-information.latest-sale-date",
        value: "",
    },
    {
        id: "sale_amt",
        title: "sale-information.latest-sale-amount",
        value: "",
    },
]

export const siteArray = [
    {
        id: "actual_frontage",
        title: "site-information.frontage",
        value: "",
    },
    {
        id: "actual_depth",
        title: "site-information.depth",
        value: "",
    },
    {
        id: "actual_lot_size",
        title: "site-information.site-area",
        value: "",
    },
    {
        id: "effective_lot_size",
        title: "site-information.effective-site-area",
        value: "",
    },
    {
        id: "managed_forest_acreage",
        title: "site-information.managed-forest-area",
        value: ""
    },
    {
        id: "land_value",
        title: "site-information.land-value",
        value: ""
    },
    {
        id: "hydro_service_desc",
        title: "site-information.hydro-service",
        value: "",
    },
    {
        id: "sanitary_service_desc",
        title: "site-information.sanitary-service",
        value: "",
    },
    {
        id: "water_service_desc",
        title: "site-information.water-service",
        value: "",
    }
]

export const improvementsArray = [
    {
        id: "imp_building_type",
        title: "improvements.building-type",
        value: ""
    },
    {
        id: "imp_year_built",
        title: "improvements.year-built",
        value: ""
    },
    {
        id: "imp_building_class",
        title: "improvements.building-class",
        value: ""
    },
    {
        id: "imp_vacancy_loss",
        title: "improvements.vacancy-loss",
        value: ""
    },
    {
        id: "imp_expense_ratio",
        title: "improvements.expense-ratio",
        value: ""
    },
    {
        id: "imp_net_operating_income",
        title: "improvements.net-operating-income",
        value: ""
    }, {
        id: "imp_capitalization_rate",
        title: "improvements.capitalization",
        value: ""
    },
    {
        id: "imp_suites",
        title: "improvements.suites",
        value: ""
    }
]

export const buildingsArray = [
    {
        id: "buildings_gfa",
        title: "buildings.gfa",
        value: ""
    },
    {
        id: "buildings_rcn",
        title: "buildings.rcn",
        value: ""
    },
    {
        id: "buildings_rcnsf",
        title: "buildings.rcnsf",
        value: ""
    },
    {
        id: "buildings_eop",
        title: "buildings.eop",
        value: ""
    }
]

export const yardworkArray = [
    {
        id: "yardwork_rcn",
        title: "yardwork.rcn",
        value: ""
    }
]

export const hotelArray = [
    {
        id: "hos_name",
        title: "additional-data.hos-name",
        value: ""
    },
    {
        id: "hotel_rating",
        title: "additional-data.hotel-rating",
        value: ""
    },
    {
        id: "hotel_room_count",
        title: "additional-data.hotel-room-count",
        value: ""
    },
    {
        id: "hotel_cap_rate",
        title: "additional-data.hotel-cap-rate",
        value: ""
    },
    {
        id: "hotel_revpar",
        title: "additional-data.hotel-revpar",
        value: ""
    }, {
        id: "hotel_val_per_room",
        title: "additional-data.hotel-val-per-room",
        value: ""
    },
]

export const motelArray = [
    {
        id: "hos_name",
        title: "additional-data.hos-name",
        value: ""
    },
    {
        id: "motel_room_count",
        title: "additional-data.motel-room-count",
        value: ""
    },
    {
        id: "motel_gim",
        title: "additional-data.motel-gim",
        value: ""
    },
    {
        id: "motel_revpar",
        title: "additional-data.motel-revpar",
        value: ""
    },
    {
        id: "motel_val_per_room",
        title: "additional-data.motel-val-per-room",
        value: ""
    },
]

export const golfArray = [
    {
        id: "hos_name",
        title: "additional-data.hos-name",
        value: ""
    },
    {
        id: "golf_hole_count",
        title: "additional-data.golf-hole-count",
        value: ""
    },
    {
        id: "golf_round_count",
        title: "additional-data.golf-round-count",
        value: ""
    },
    {
        id: "golf_prime_rate",
        title: "additional-data.golf-prime-rate",
        value: ""
    },
    {
        id: "golf_cap_rate",
        title: "additional-data.golf-cap-rate",
        value: ""
    },
]

export const retirementArray = [
    {
        id: "hos_name",
        title: "additional-data.hos-name",
        value: ""
    },
    {
        id: "retirement_room_count",
        title: "additional-data.retirement-room-count",
        value: ""
    },
    {
        id: "retirement_operating_expenses",
        title: "additional-data.retirement-operating-expenses",
        value: ""
    },
    {
        id: "retirement_cap_rate",
        title: "additional-data.retirement-cap-rate",
        value: ""
    },
    {
        id: "retirement_val_per_room",
        title: "additional-data.retirement-val-per-room",
        value: ""
    }

]

export const ltcArray = [
    {
        id: "hos_name",
        title: "additional-data.hos-name",
        value: ""
    },
    {
        id: "ltc_design_type",
        title: "additional-data.ltc-design-type",
        value: ""
    },
    {
        id: "ltc_licensed_beds",
        title: "additional-data.ltc-licensed-beds",
        value: ""
    },
    {
        id: "ltc_operating_expenses",
        title: "additional-data.ltc-operating-expenses",
        value: ""
    },
    {
        id: "ltc_cap_rate",
        title: "additional-data.ltc-cap-rate",
        value: ""
    },
    {
        id: "ltc_val_per_bed",
        title: "additional-data.ltc-val-per-bed",
        value: ""
    },
]

export const primaryStructuresArray = [
    { id: "structure_cd", title: 'primary-structures.structure-description', value: '' },
    { id: "actual_year_built", title: 'primary-structures.year-built', value: '' },
    { id: "condition", title: 'primary-structures.condition', value: '' },
    { id: "renovation_year", title: 'primary-structures.renovation-year', value: '' },
    { id: "addition_year", title: 'primary-structures.addition-year', value: '' },
    { id: "air_conditioning_flg", title: 'primary-structures.central-air', value: '' },
    { id: "central_heating_desc", title: 'primary-structures.heat-type', value: '' },
    { id: "total_fireplaces_cnt", title: 'primary-structures.fireplace-total', value: 0 },
    { id: "total_full_baths_cnt", title: 'primary-structures.full-baths', value: 0 },
    { id: "total_half_baths_cnt", title: 'primary-structures.half-baths', value: 0 },
    { id: "total_bedrooms_cnt", title: 'primary-structures.bedrooms', value: 0 },
    { id: "total_full_storeys_cnt", title: 'primary-structures.full-storeys', value: 0 },
    { id: "part_storey_desc", title: 'primary-structures.partial-storey', value: '' },
    { id: "first_floor_area", title: 'primary-structures.first-floor-area', value: '' },
    { id: "second_floor_area", title: 'primary-structures.second-floor-area', value: '' },
    { id: "upper_floor_area", title: 'primary-structures.upper-floor-area', value: '' },
    { id: "total_floor_area", title: 'primary-structures.exterior-square-footage', value: '' },
    { id: "total_basement_area", title: 'primary-structures.total-basement-area', value: '' },
    { id: "finished_basement_area", title: 'primary-structures.finished-basement-area', value: '' },
    { id: "basement_height", title: 'primary-structures.basement-height', value: 0 }
]

export const secondaryStructuresArray = [
    { id: "s_structure_cd_desc", title: 'other-structures.structure-description', value: '' },
    { id: "s_actual_year_built", title: 'other-structures.year-built', value: '' },
    { id: "s_total_full_storeys_cnt", title: 'other-structures.total-full-storeys-cnt', value: 0 },
    { id: "s_area", title: 'other-structures.area', value: '' },
    { id: "s_construction_quality_desc", title: 'other-structures.construction-quality', value: 0 },
    { id: "s_height", title: 'other-structures.height', value: 0 },
    { id: "s_condition", title: 'other-structures.condition', value: "" }
]

export const dataElementsArray = [
    { id: "abuts", title: 'locational-influences.abuts', value: '' },
    { id: "proximities", title: 'locational-influences.proximity', value: '' },
    { id: "on_sites", title: 'locational-influences.onsite', value: '' },
    { id: "waterfronts", title: 'locational-influences.waterfront', value: '' },
]

export const accordionDataArray = [
    {
        id: 'property',
        title: "property-information.title",
        data: propertyArray,
    },
    {
        id: 'valuation',
        title: "valuation.title",
        data: valuationArray,
    },
    {
        id: 'sale',
        title: "sale-information.title",
        data: saleArray,
    },
    {
        id: 'site',
        title: "site-information.title",
        data: siteArray,
    },
    {
        id: 'primary_structures',
        title: "primary-structures.title",
        data: primaryStructuresArray,
    },
    {
        id: 'secondary_structures',
        title: "other-structures.title",
        data: secondaryStructuresArray
    },
    {
        id: 'data_elements',
        title: "locational-influences.title",
        data: dataElementsArray
    },
    {
        id: 'improvements',
        title: "improvements.title",
        data: improvementsArray
    },
    {
        id: 'buildings',
        title: "buildings.title",
        data: buildingsArray
    },
    {
        id: 'yardwork',
        title: 'yardwork.title',
        data: yardworkArray
    },
    {
        id: 'hotel',
        title: 'additional-data.title',
        data: hotelArray
    },
    {
        id: 'motel',
        title: 'additional-data.title',
        data: motelArray
    },
    {
        id: 'golf',
        title: 'additional-data.title',
        data: golfArray
    },
    {
        id: 'retirement',
        title: 'additional-data.title',
        data: retirementArray
    },
    {
        id: 'ltc',
        title: 'additional-data.title',
        data: ltcArray
    },
]
